import React, { useState } from "react";
import { FaWhatsapp, FaPhoneAlt, FaShoppingCart, FaLeaf, FaWater, FaSeedling, FaShieldAlt, FaIndustry, FaCogs, FaBoxes } from "react-icons/fa";

// Mock image - replace with actual image path
import coco25kgImg from "../../assets/products/25g.png";

const Cocopeat25kgBags = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [activeTab, setActiveTab] = useState('description');
  
  const whatsappNumber = "+919492228585";
  const whatsappMessage = encodeURIComponent(
    "Hello Mr.Ramana Sir! I'm interested in ordering the Cocopeat 25kg Bags. Could you please provide more details?"
  );

  const handleOrderClick = () => {
    setShowOptions(!showOptions);
  };

  const benefits = [
    { icon: <FaLeaf />, title: "100% Organic", desc: "Natural and eco-friendly growing medium" },
    { icon: <FaWater />, title: "High Water Retention", desc: "Excellent water retention and gradual release" },
    { icon: <FaSeedling />, title: "Root Development", desc: "Promotes excellent root growth with high porosity" },
    { icon: <FaShieldAlt />, title: "Pest-Free", desc: "Organic and environmentally friendly for healthy crops" },
    { icon: <FaIndustry />, title: "Large Scale", desc: "Perfect for commercial horticulture and farming" },
    { icon: <FaCogs />, title: "Controlled Growth", desc: "Uniform distribution ensures controlled growth media" }
  ];

  const specifications = [
    { param: "Dimensions", value: "33 cm x 44 cm x 80 cm" },
    { param: "Material", value: "Coco peat or Coco peat and coco chips mix" },
    { param: "Weight", value: "25 Kg" },
    { param: "Load Ability", value: "Floor loading: 600 bales per 40ft HC, Pallet loading: 560 bales per container" },
    { param: "Mixture", value: "70% coco peat & 30% fiber OR 50% coco peat & 50% fiber" },
    { param: "EC Level", value: "EC<0.2 to EC>1.5 mS/cm (Super washed, Washed, Unwashed)" },
    { param: "pH Value", value: "5.5 - 6.3" }
  ];

  return (
    <div className="min-h-screen bg-gray-50 shadow-md my-10">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-green-50 to-green-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Product Image */}
            <div className="order-1 lg:order-1">
              <div className="relative bg-white rounded-2xl shadow-xl p-6 lg:p-8">
                <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  25kg
                </div>
                <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  <FaIndustry className="inline mr-1" />
                  Commercial
                </div>
                <img
                  src={coco25kgImg}
                  alt="Cocopeat 25kg Bags"
                  className="w-full h-64 sm:h-80 lg:h-96 object-contain rounded-lg"
                />
              </div>
            </div>

            {/* Product Info */}
            <div className="order-2 lg:order-2 space-y-6">
              <div>
                <h1 className="text-2xl sm:text-4xl lg:text-4xl font-bold text-gray-900 mb-4">
                  Cocopeat 25kg Bags
                </h1>
                <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
                  Professional-grade coco peat bags ideal for large-scale gardening and horticultural needs. Perfect for commercial farming and soil-less cultivation.
                </p>
              </div>

              <div className="flex flex-wrap gap-2">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                  <FaLeaf className="mr-1" /> 100% Organic
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                  <FaIndustry className="mr-1" /> Commercial Grade
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
                  <FaBoxes className="mr-1" /> Bulk Quantity
                </span>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-lg">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Key Features</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="flex items-center space-x-2">
                    <FaBoxes className="text-green-600" />
                    <span className="text-gray-700">25kg Industrial Pack</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <FaWater className="text-blue-600" />
                    <span className="text-gray-700">High Water Retention</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <FaSeedling className="text-green-600" />
                    <span className="text-gray-700">pH 5.5-6.3</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <FaCogs className="text-purple-600" />
                    <span className="text-gray-700">Multiple Mix Options</span>
                  </div>
                </div>
              </div>

              <div className="bg-orange-50 border-l-4 border-orange-400 p-4">
                <p className="text-orange-800 font-medium">
                  <FaIndustry className="inline mr-2" />
                  Perfect for: Commercial farming, large-scale horticulture, and soil-less cultivation
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Product Details Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Tabs */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-2 sm:gap-4 border-b border-gray-200">
            {['description', 'specifications', 'benefits'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 text-sm sm:text-base font-medium capitalize transition-colors duration-200 border-b-2 ${
                  activeTab === tab
                    ? 'text-green-600 border-green-600'
                    : 'text-gray-500 border-transparent hover:text-green-600 hover:border-green-300'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-xl shadow-lg p-6 lg:p-8">
          {activeTab === 'description' && (
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-gray-900">Product Description</h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                The 25 kg cocopeat bags is a large, compressed block of coco peat that expands significantly when hydrated. It is widely used in large-scale horticulture, farming, and soil-less cultivation, providing excellent water retention, aeration, and root development for various plants.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-green-50 border-l-4 border-green-400 p-4">
                  <h4 className="font-semibold text-green-800 mb-2">Commercial Applications</h4>
                  <p className="text-green-700">
                    Ideal for large-scale farming, commercial nurseries, and industrial cultivation projects.
                  </p>
                </div>
                <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
                  <h4 className="font-semibold text-blue-800 mb-2">Shipping Efficiency</h4>
                  <p className="text-blue-700">
                    Optimized for container shipping with 600 bales per 40ft HC or 560 bales per pallet.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'specifications' && (
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-gray-900">Technical Specifications</h2>
              <div className="overflow-x-auto">
                <table className="w-full border-collapse bg-white">
                  <thead>
                    <tr className="bg-green-50">
                      <th className="border border-gray-300 p-4 text-left font-semibold text-gray-900">Parameter</th>
                      <th className="border border-gray-300 p-4 text-left font-semibold text-gray-900">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {specifications.map((spec, index) => (
                      <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                        <td className="border border-gray-300 p-4 font-medium text-gray-700">{spec.param}</td>
                        <td className="border border-gray-300 p-4 text-gray-700">{spec.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                <p className="text-yellow-800 font-medium">
                  💡 Note: Available in multiple mixture ratios and EC levels to suit different cultivation needs.
                </p>
              </div>
            </div>
          )}

          {activeTab === 'benefits' && (
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-gray-900">Key Benefits</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {benefits.map((benefit, index) => (
                  <div key={index} className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-md transition-shadow duration-200">
                    <div className="text-3xl text-green-600 mb-3 flex justify-center">{benefit.icon}</div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{benefit.title}</h3>
                    <p className="text-gray-600">{benefit.desc}</p>
                  </div>
                ))}
              </div>
              <div className="bg-gray-100 rounded-xl p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Additional Benefits</h3>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-gray-700">
                  <li className="flex items-start space-x-2">
                    <span className="text-green-600 mt-1">✓</span>
                    <span>Cost-effective and reusable with convenient storage</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-green-600 mt-1">✓</span>
                    <span>Uniform distribution ensures controlled growth media</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-green-600 mt-1">✓</span>
                    <span>High water retention with gradual release</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-green-600 mt-1">✓</span>
                    <span>Promotes excellent root growth with high porosity</span>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Shipping & Container Info Section */}
      <div className="bg-blue-50 border-t border-blue-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Shipping & Container Information</h2>
            <p className="text-xl text-gray-600">Optimized for efficient bulk shipping and logistics</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                <FaBoxes className="mr-2 text-blue-600" />
                Floor Loading
              </h3>
              <p className="text-gray-700 text-lg">
                <strong>600 bales</strong> per 40ft HC container
              </p>
              <p className="text-gray-600 mt-2">Maximum efficiency for direct floor loading</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                <FaCogs className="mr-2 text-green-600" />
                Pallet Loading
              </h3>
              <p className="text-gray-700 text-lg">
                <strong>560 bales</strong> per container
              </p>
              <p className="text-gray-600 mt-2">Organized pallet loading for easy handling</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-green-600 to-green-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center space-y-6">
            <h2 className="text-3xl sm:text-4xl font-bold">Ready for Large-Scale Cultivation?</h2>
            <p className="text-xl text-green-100 max-w-2xl mx-auto">
              Get your bulk cocopeat bags today and experience professional-grade growing medium for your commercial projects.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-green-600 px-8 py-3 rounded-full font-semibold text-lg hover:bg-green-50 transition-all duration-300 flex items-center space-x-2 hover:scale-105"
              >
                <FaWhatsapp className="text-xl" />
                <span>Order via WhatsApp</span>
              </a>
              <a
                href={`tel:${whatsappNumber}`}
                className="bg-green-800 text-white px-8 py-3 rounded-full font-semibold text-lg hover:bg-green-900 transition-all duration-300 flex items-center space-x-2 hover:scale-105"
              >
                <FaPhoneAlt className="text-xl" />
                <span>Call Now</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Action Button */}
      <div
        onClick={handleOrderClick}
        className="fixed bottom-6 right-6 bg-green-600 text-white p-4 rounded-full shadow-xl hover:bg-green-700 transition-all duration-300 cursor-pointer hover:scale-110 z-50"
      >
        <FaShoppingCart className="text-xl" />
      </div>

      {/* Floating Options Menu */}
      <div
        className={`fixed bottom-24 right-6 transform transition-all duration-300 ease-in-out z-40 ${
          showOptions
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10 pointer-events-none"
        }`}
      >
        <div className="bg-white shadow-xl rounded-xl p-4 space-y-3 border">
          <a
            href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-3 bg-green-600 text-white px-4 py-3 rounded-lg hover:bg-green-700 transition-all duration-300 hover:scale-105"
          >
            <FaWhatsapp className="text-xl" />
            <span className="font-medium">WhatsApp</span>
          </a>
          <a
            href={`tel:${whatsappNumber}`}
            className="flex items-center space-x-3 bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-all duration-300 hover:scale-105"
          >
            <FaPhoneAlt className="text-xl" />
            <span className="font-medium">Call Now</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Cocopeat25kgBags;